<template>
  <div>
    <Vetster-editorial-module-concern-with
      v-if="isMinorConcern"
      :post="post"
      :mobile-apps="mobileApps"
    />
    <Vetster-editorial-module-are-you-concerned v-else />
  </div>
</template>

<script>
import VetsterEditorialModuleAreYouConcerned from '@/brand-components/Content/PetHealth/VetsterEditorialModuleAreYouConcerned';
import VetsterEditorialModuleConcernWith from '@/brand-components/Content/PetHealth/VetsterEditorialModuleConcernWith';
import DegreeOfUrgency from '@/enums/DegreeOfUrgency';

export default {
  name: 'VetsterEditorialModule',

  components: {
    VetsterEditorialModuleAreYouConcerned,
    VetsterEditorialModuleConcernWith,
  },

  props: {
    mobileApps: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isMinorConcern() {
      return this.post.degree_of_urgency === DegreeOfUrgency.Minor;
    },
  },
};
</script>
